import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { CardHeader, Card, CardBody, Col, Input, Row, Modal } from "reactstrap";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { api } from "../../../config";
import { fetchComAuthJson, fetchComAuth } from '../../../common/api';

const Lista = () => {
  const [feirasData, setFeiraData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalDuplicar, setModalDuplicar] = useState(false);
  const [modalRenovar, setModalRenovar] = useState(false);
  const [modalCopiar, setModalCopiar] = useState(false);
  const [feiraSelecionada, setFeiraSelecionada] = useState(null);
  const [search, setSearch] = useState("");
  const [renovando, setRenovando] = useState(false);
  const [copiando, setCopiando] = useState(false);
  const [duplicando, setDuplicando] = useState(false);

  const filteredFeiras = feirasData.filter((feira) =>
    feira.nome.toLowerCase().includes(search.toLowerCase())
  );

  const confirmarExclusao = (feira) => {
    setFeiraSelecionada(feira);
    setModalDelete(true);
  };

  const confirmarDuplicar = (feira) => {
    setFeiraSelecionada(feira);
    setModalDuplicar(true);
  };

  const confirmarRenovar = (feira) => {
    setFeiraSelecionada(feira);
    setModalRenovar(true);
  };

  const confirmarCopiar = (feira) => {
    setFeiraSelecionada(feira);
    setModalCopiar(true);
  };

  const handleDelete = async () => {
    if (!feiraSelecionada) return;

    try {
      const response = await fetchComAuth(`${api.API_URL}/feira/${feiraSelecionada.id}`, {
        method: 'DELETE'
      })
     
      if (response.ok) {
        setFeiraData((prev) =>
          prev.filter((feira) => feira.id !== feiraSelecionada.id)
        );
        toast.success("Feira excluída com sucesso!");
      } else {
        toast.error("Erro ao excluir feira.");
      }
    } catch (error) {
      console.error("Erro ao excluir feira:", error);
      toast.error("Erro na comunicação com o servidor.");
    } finally {
      setModalDelete(false);
      setFeiraSelecionada(null);
    }
  };

const handleDuplicar = async () => {
  if (!feiraSelecionada || duplicando) return; // Proteção extra

  setDuplicando(true); // Ativa o bloqueio
  try {
    const response = await fetchComAuth(`${api.API_URL}/feira/duplicar/${feiraSelecionada.id}`, {
      method: 'POST'
    });
  
    if (response.ok) {
      toast.success("Feira duplicada com sucesso!");
      await fetchFeiras(); 
    } else {
      toast.error("Erro ao duplicar a feira.");
    }
  } catch (error) {
    console.error("Erro ao duplicar a feira:", error);
    toast.error("Erro na comunicação com o servidor.");
  } finally {
    setDuplicando(false); // Libera o estado
    setModalDuplicar(false);
    setFeiraSelecionada(null);
  }
};

// --- FUNÇÃO RENOVAR ---
const handleRenovar = async () => {
  if (!feiraSelecionada || renovando) return;

  setRenovando(true);
  try {
    const response = await fetchComAuth(`${api.API_URL}/feira/renovar/${feiraSelecionada.id}`, {
      method: 'POST'
    });

    if (response.ok) {
      toast.success("Feira renovada com sucesso!");
      await fetchFeiras(); 
    } else {
      toast.error("Erro ao renovar a feira.");
    }
  } catch (error) {
    console.error("Erro ao renovar a feira:", error);
    toast.error("Erro na comunicação com o servidor.");
  } finally {
    setRenovando(false);
    setModalRenovar(false);
    setFeiraSelecionada(null);
  }
};

const handleCopiar = async () => {
  if (!feiraSelecionada || copiando) return;

  setCopiando(true);
  try {
    const response = await fetchComAuth(`${api.API_URL}/feira/copiar/${feiraSelecionada.id}`, {
      method: 'POST'
    });
    
    if (response.ok) {
      toast.success("Feira copiada com sucesso!");
      await fetchFeiras(); 
    } else {
      toast.error("Erro ao copiar a feira.");
    }
  } catch (error) {
    console.error("Erro ao copiar a feira:", error);
    toast.error("Erro na comunicação com o servidor.");
  } finally {
    setCopiando(false);
    setModalCopiar(false);
    setFeiraSelecionada(null);
  }
};
      
  const fetchFeiras = async () => {
    try {
      const response = await fetchComAuthJson(`${api.API_URL}/feiras`, {
        method: 'GET',
      })

      const data = await response.json();
      
      setFeiraData(data.data || []);
    } catch (error) {
      console.error("Erro ao buscar feiras:", error);
    } finally {
      setIsLoading(false);
    }
  };
    
  useEffect(() => {
    fetchFeiras();
  }, []);
  
  const copiarLink = (feira, nomeSlug) => {
    const urlBase = window.location.origin;
    const path = feira.renovacao ? 'renovacao' : 'vendas';
    const linkCompleto = `${urlBase}/${nomeSlug}/${path}/${feira.id}`;
    
    navigator.clipboard.writeText(linkCompleto);
    // ex: Alerta de link copiado com sucesso...
  };

  return (
    <React.Fragment>
      <ToastContainer closeButton={false} />

      <Row>
        <Col lg={12}>
          <Card>
            <CardHeader>
              <Row className="g-4">
                <div className="col-sm-auto">
                  <div>
                    <Link to="/feira-cadastro" className="btn btn-success">
                      <i className="ri-add-line align-bottom me-1"></i>{" "}
                      Adicionar
                    </Link>
                  </div>
                </div>
                <div className="col-sm-3 ms-auto">
                  <div className="d-flex justify-content-sm-end gap-2">
                    <div className="search-box ms-2 col-sm-7">
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Pesquise por nome..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </div>
                </div>
              </Row>
            </CardHeader>
            <CardBody>
              <div className="listjs-table" id="listaFeiras">
                {isLoading ? (
                  <p className="text-center">Carregando feiras...</p>
                ) : (
                  <div className="table-responsive table-card mb-1">
                    <table
                      className="table align-middle table-nowrap"
                      id="customerTable"
                    >
                      <thead className="table-light">
                        <tr>
                          <th className="sort" data-sort="nome">
                            Nome
                          </th>
                          <th className="sort" data-sort="link">
                            Vendas
                          </th>
                          <th className="sort" data-sort="atualizado_em">
                            Atualizado em
                          </th>
                          <th className="sort" data-sort="action">
                            Opções
                          </th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {filteredFeiras.map((feira, index) => {
                          // 1. Função interna ou tratamento para gerar o slug do nome da feira
                          // Exemplo: "Feira de Agronegócio 2026" vira "feira-de-agronegocio-2026"
                          const nomeSlug = feira.nome
                            ? feira.nome
                                .toLowerCase()
                                .normalize("NFD") // Remove acentos
                                .replace(/[\u0300-\u036f]/g, "") // Remove acentos
                                .replace(/[^a-z0-9\s-]/g, "") // Remove caracteres especiais
                                .trim()
                                .replace(/\s+/g, "-") // Troca espaços por hífen
                            : "feira";

                          return (
                            <tr key={index}>
                              <td>
                                <div className="d-flex">
                                  <div className="flex-shrink-0 avatar-md bg-primary rounded p-1">
                                    <img
                                      src={feira.logoUrl}
                                      alt=""
                                      className="img-fluid d-block"
                                    />
                                  </div>
                                  <div className="flex-grow-1 ms-3">
                                    <h5 className="fs-15">{feira.nome}</h5>
                                    <p className="text-muted mb-0">
                                      {feira.descricao.length > 50
                                        ? feira.descricao.substring(0, 50)
                                        : feira.descricao}
                                    </p>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex gap-2">
                                  {feira.habilitada_vendas == true ? (
                                    <>
                                      <button
                                        className="btn btn-info"
                                        onClick={() => copiarLink(feira, nomeSlug)} // <-- Passando o nomeSlug tratado aqui, caso use na função
                                      >
                                        <i className="ri-share-line text-white"></i>
                                      </button>

                                      <li className="btn btn-success" title="Abrir mapa">
                                        {/* Atualizado com a nova estrutura de URL */}
                                        <Link 
                                          to={feira.renovacao 
                                            ? `/${nomeSlug}/renovacao/${feira.id}` 
                                            : `/${nomeSlug}/vendas/${feira.id}`
                                          }
                                        >
                                          <i className="ri-eye-fill align-bottom text-white"></i>
                                        </Link>
                                      </li>
                                    </>
                                  ) : (
                                    <span>Não habilitada</span>
                                  )}
                                  
                                  {feira.habilitada_rotas && (
                                    <li className="btn btn-primary" title="Rotas">
                                      {/* Atualizado com a nova estrutura de URL */}
                                      <Link to={`/${nomeSlug}/rotas/${feira.id}`}>
                                        <i className="ri-map-pin-line align-bottom text-white"></i>
                                      </Link>
                                    </li>
                                  )}
                                </div>
                              </td>
                              <td>
                                <small className="text-muted">
                                  {new Date(feira.updated_at).toLocaleString("pt-BR", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </small>
                              </td>

                              <td>
                                <div className="d-flex gap-2">
                                  <Link
                                    to={`/feira-cadastro/${feira.id}`}
                                    className="btn btn-sm btn-success"
                                  >
                                    Editar
                                  </Link>

                                  <button
                                    className="btn btn-sm btn-danger"
                                    onClick={() => confirmarExclusao(feira)}
                                  >
                                    Remover
                                  </button>

                                  <button
                                    className="btn btn-sm btn-info"
                                    onClick={() => confirmarDuplicar(feira)}
                                  >
                                    Duplicar
                                  </button>

                                  <button
                                    className="btn btn-sm btn-warning"
                                    onClick={() => confirmarRenovar(feira)}
                                  >
                                    Renovar
                                  </button>

                                  <button
                                    className="btn btn-sm btn-secondary"
                                    onClick={() => confirmarCopiar(feira)}
                                  >
                                    Copiar
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      {/* <tbody className="list form-check-all">
                        {filteredFeiras.map((feira, index) => (
                          <tr key={index}>
                            <td>
                              <div className="d-flex">
                                <div className="flex-shrink-0 avatar-md bg-primary rounded p-1">
                                  <img
                                    src={feira.logoUrl}
                                    alt=""
                                    className="img-fluid d-block"
                                  />
                                </div>
                                <div className="flex-grow-1 ms-3">
                                  <h5 className="fs-15">{feira.nome}</h5>
                                  <p className="text-muted mb-0">
                                    {feira.descricao.length > 50
                                      ? feira.descricao.substring(0, 50)
                                      : feira.descricao}
                                  </p>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex gap-2">
                              {feira.habilitada_vendas == true ? (
                                <>
                                  <button
                                    className="btn btn-info"
                                    onClick={() => copiarLink(feira)}
                                  >
                                    <i className="ri-share-line text-white"></i>
                                  </button>

                                  <li
                                    className="btn btn-success"
                                    title="Abrir mapa"
                                  >
                                    <Link to={feira.renovacao ? "/renovacao/" + feira.id : "/vendas/" + feira.id}>
                                      <i className="ri-eye-fill align-bottom text-white"></i>
                                    </Link>
                                  </li>
                                </>
                              
                              ) : (
                                <span>Não habilitada</span>
                              )}
                              {
                                feira.habilitada_rotas && (
                                  <li className="btn btn-primary" title="Rotas">
                                    <Link to={"/rotas/" + feira.id}>
                                      <i className="ri-map-pin-line align-bottom text-white"></i>
                                    </Link>
                                  </li>
                                  )
                              }
                                </div>
                            </td>
                            <td>
                              <small className="text-muted">
                                {new Date(feira.updated_at).toLocaleString(
                                  "pt-BR",
                                  {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  }
                                )}
                              </small>
                            </td>
                           
                            <td>
                              <div className="d-flex gap-2">
                                <Link
                                  to={`/feira-cadastro/${feira.id}`}
                                  className="btn btn-sm btn-success"
                                >
                                  Editar
                                </Link>

                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() => confirmarExclusao(feira)}
                                >
                                  Remover
                                </button>

                                <button
                                  to="#"
                                  className="btn btn-sm btn-info"
                                  onClick={() => confirmarDuplicar(feira)}
                                >
                                  Duplicar
                                </button>

                                <button
                                  to="#"
                                  className="btn btn-sm btn-warning"
                                  onClick={() => confirmarRenovar(feira)}
                                >
                                  Renovar
                                </button>

                                 <button
                                  to="#"
                                  className="btn btn-sm btn-secondary"
                                  onClick={() => confirmarCopiar(feira)}
                                  >
                                    Copiar
                                  </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody> */}
                    </table>
                    {filteredFeiras.length === 0 && (
                      <div className="noresult">
                        <div className="text-center py-4">
                          <h5 className="mt-2">Nenhum resultado encontrado</h5>
                          <p className="text-muted mb-0">
                            Não há feiras cadastradas no momento.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="d-flex justify-content-end">
                  <div className="pagination-wrap hstack gap-2">
                    <Link className="page-item pagination-prev disabled" to="#">
                      Anterior
                    </Link>
                    <ul className="pagination listjs-pagination mb-0"></ul>
                    <Link className="page-item pagination-next" to="#">
                      Próximo
                    </Link>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row className="g-0 text-center text-sm-start align-items-center mt-4">
        <Col sm={6}>
          <p className="mb-sm-0 text-muted">
            Exibindo{" "}
            <span className="fw-semibold">{filteredFeiras.length}</span> feiras
          </p>
        </Col>
      </Row>

      <Modal isOpen={modalDelete} toggle={() => setModalDelete(false)} centered>
        <div className="modal-header">
          <h5 className="modal-title">Confirmar exclusão</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setModalDelete(false)}
          ></button>
        </div>
        <div className="modal-body text-center">
          <p className="fs-15">
            Tem certeza que deseja excluir a feira{" "}
            <strong>{feiraSelecionada?.nome}</strong>?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setModalDelete(false)}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={handleDelete}
          >
            Confirmar
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={modalDuplicar}
        toggle={() => setModalDuplicar(false)}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title">Confirmar DUPLICAR</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setModalDuplicar(false)}
          ></button>
        </div>
        <div className="modal-body text-center">
          <p className="fs-15">
            Tem certeza que deseja duplicar a feira{" "}
            <strong>{feiraSelecionada?.nome}</strong>?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setModalDuplicar(false)}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={handleDuplicar}
            disabled={duplicando}      
          >
            {duplicando ? "Processando..." : "Confirmar"}
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={modalRenovar}
        toggle={() => setModalRenovar(false)}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title">Confirmar Renovação</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setModalRenovar(false)}
          ></button>
        </div>
        <div className="modal-body text-center">
          <p className="fs-15">
            Tem certeza que deseja renovar a feira{" "}
            <strong>{feiraSelecionada?.nome}</strong>?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setModalRenovar(false)}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={handleRenovar}
            disabled={renovando}
            >
              {renovando ? "Processando..." : "Confirmar"}
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={modalCopiar}
        toggle={() => setModalCopiar(false)}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title">Confirmar cópia</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setModalCopiar(false)}
          ></button>
        </div>
        <div className="modal-body text-center">
          <p className="fs-15">
            Tem certeza que deseja copiar a feira{" "}
            <strong>{feiraSelecionada?.nome}</strong>?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setModalCopiar(false)}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={handleCopiar}
            disabled={copiando}
            >
              {copiando ? "Processando..." : "Confirmar"}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default Lista;
